.terms {
  font-weight: 400;
  font-size: 12px;
  line-height: 13px;
  color: #7b798f;
}

.warning {
  border-radius: 32px;
  background: #F3EDDF;
  color: #231E19;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.045px;
  padding: 20px;

  ul {
    padding-left: 20px;
  }

  li + li {
    margin-top: 8px;
  }
}